//en.js
const en = {
  home: {
    home: 'Home',
    solutions: 'Solutions',
    support: 'Support',
    news: 'News',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    cgm: 'CGM',
    download: 'Downloads',
    helpCenter: 'Help Center',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. All rights reserved.',
    menu: 'Menu',
    investors: 'Board Of Directors',
    quickLinks: 'Quick Links',
    hipCgm: 'HIPPO CGM',
    careers: 'Careers',
    contact: 'Contact',
    legal: 'Legal',
    termsUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    portal: 'User’s Portal',
    emailPlaceholder: 'Mail',
    subscribe: 'Subscribe',
    signUp: 'Sign up to receive latest news',
    downloadApp: 'Download App',
    blogNews: 'Blog & News',
    latestArticles: 'Latest Articles',
    viewAllArticles: 'View all articles',
    empower: 'Empower Your Health Journey with Us',
    reliable: 'Your Reliable Diabetes Management Partner',
    hippoH1: 'HiPPO H1',
    mard: 'World-leading accuracy with a MARD of 7.43%',
    living: 'Living with Diabetes',
    challeng: 'Challenges and How Hippo Biosensors Can Help',
    medical:
      'Hippo BioSensors understand the unique challenges faced by people living with diabetes. Managing blood sugar levels can be a constant struggle, impacting your daily routine and overall well-being.',
    challenges: 'Challenges',
    constant: 'Constant Blood Sugar Monitoring',
    traditional:
      'Traditional finger pricking for blood glucose checks can be painful and inconvenient',
    dataOverload: 'Data Overload',
    managing:
      'Managing blood sugar data from multiple sources can be overwhelming and difficult to interpret',
    treatment: 'Treatment Adjustments',
    accurately:
      'Accurately determining the right course of action based on blood sugar readings can be complex',
    lifestyle: 'Lifestyle Integration',
    balancing:
      'Balancing meals, exercise, and medication with daily activities can be a challenge',
    hippoCan: 'Hippo Biosensors Offer',
    painless: 'Painless and Discreet Monitoring',
    ourCgm:
      'Our CGM provide continuous blood sugar readings without the need for finger pricking',
    realTime: 'Real-Time Data and Insights',
    accessYour:
      'Access your blood sugar data conveniently on your smartphone, allowing you to see trends and make informed decisions',
    personalized: 'Personalized Support',
    ourCgmSys:
      'Alerts and reminders from Hippo BioSensors APP  can help you stay on track with your treatment plan.',
    improved: 'Improved Decision-Making',
    gain: 'Deeper understanding of how your body responds to events, empowering you to better compensate glucose fluctuations. The real-time feedback allows you to make adjustments to your daily activities more effectively.',
    about: 'About',
    hippoBiosensors: 'HiPPO Biosensors',
    whatWe: 'What we do',
    hippoMedical:
      'Hippo BioSensors is dedicated to revolutionizing diabetes management through advanced Equipment for continuous glucose monitoring. Our mission is to empower individuals with diabetes to lead healthier, more fulfilling lives with the help of our innovative technology',
    companyProfile: 'Company Profile',
    boardOfDirectors: 'Management Team',
    // Home banners
    banner1Title: 'Welcome to Hippo Medical',
    banner1Content: 'At the forefront of CGM innovation',
    banner2Title: 'Welcome to Hippo Medical',
    banner2Content: 'Setting new standards in CGM technology.',
    banner3Title: '',
    banner3Content: 'Round-the-clock glucose protection.',
    banner4Title: 'Welcome to Hippo Medical',
    banner4Content: 'Leading the way in CGM Technology'
  },
  cgm: {
    whyChoose: 'Why Choose HiPPO CGM',
    accurate: 'Accuracy you can trust',
    accurateText: 'The third-generation enzyme technology brings more',
    accurateText1: 'stable and accurate performance',
    easyUse: 'Easy to Use',
    easyUseText: '14 days continuous monitoring',
    easyUseText1: '',
    realTime: 'Monitoring ',
    realTimeText: 'Real-time hypo&hyperglycemia reminder',
    realTimeText1: 'Real-time data sharing with family members & HCP',
    safe: 'Safe',
    safeText: 'Over 1000 clinial usage',
    safeText1: 'Certified software & data safety',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    mard: 'MARD 7.43%, World Leading Accuracy',
    waterproof: 'IPX7, waterproof for daily use',
    small: 'Small & Descrete to wear',
    keep: 'Keep you informed anywhere & anytime',
    withHippo: 'With HiPPO APPS & Portal',
    smallSensors: '-Small sensors, comfortable wear',
    agpReport:
      '-Profession AGP Report allowed HCPs & Users capture the key information immediately',
    unlimitedFollow: '-Unlimited follow, empower HCPs to manage more users',
    iWatchApp: '-iWatch App available',
    feature: 'Feature/Testimony',
    lorem:
      'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores',
    certified: 'Certified Use for Children',
    loremIp:
      'The system is clinically validated and officially certified for pediatric above 3-year old use, ensuring safety, accuracy, and comfort for younger patients.\n\nWith proven sensor accuracy and gentle, skin-friendly materials, it provides reliable glucose monitoring for children and adolescents — supporting healthcare professionals in delivering confident, data-driven diabetes care.'
  },
  news: {
    newsletters: 'Newsletters',
    date: 'Date',
    recommendedArticles: 'Recommended Articles'
  },
  support: {
    download: 'Download Guides',
    supportDown: 'Support/Downloads'
  },
  about: {
    welcome: 'Welcome to Hippo Medical',
    contact: 'Contact Us Now',
    covered: 'Covered Countries',
    patents: 'Patents',
    features: 'Features3',
    solutions: 'Our Solutions',
    ring: 'Ring',
    apparently:
      'A mysterious ring that can monitor parameters such as blood oxygen, heart rate, and sleep. More importantly, it has an algorithmic connection with our CGM. Launching in 2026. Stay tuned!',
    cgmSky:
      'A professional CGM designed with both patient usage and doctor’s clinical needs in mind. It offers high accuracy, user-friendly software interaction, and is powered by Hippo Medical algorithms. Launching in June 2025!',
    smartWatch: 'Smart Watch',
    byTheSame:
      'A wearable dynamic blood pressure monitoring device that can continuously track systolic pressure, diastolic pressure, mean arterial pressure, and more, featuring an algorithm developed by Hippo  Medical. Launching in 2026. Stay tuned!',
    explore: 'Explore',
    customer: 'Our Customer',
    aBusiness:
      'A business is defined as an organization or enterprising entity engaged in commercial, industrial.',
    defined:
      'Defined as an organization or enterprising entity engaged in commercial, industrial, or professional activities. The term “business” also refers to the organized efforts and activities.',
    effective: 'Effective Strategy',
    growth: 'For Growth',
    mission: 'Mission & Vision',
    aim: 'We aim to provide accurate, real-time glucose monitoring solutions that simplify diabetes management, enabling users to make informed health decisions. Our vision is a world where diabetes management is seamless and stress-free',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SINGAPORE(409051)',
    zipCode: 'ZIP Code',
    emailCode: '409051',
    email: 'Email',
    emailText: 'info@hippodiabetes.com',
    name: 'Name*',
    company: 'Company',
    message: 'Message',
    phone: 'Phone',
    submit: 'Submit',
    commingSoon: 'Comming Soon',
    aboutUs: 'About Us',
    cpInfo1:
      'Hippo Medical is a global MedTech company, headquartered in Singapore, dedicated to revolutionizing chronic disease management with medical-grade wearable biosensors. Our vision is to provide continuous monitoring and advanced data analysis.',
    cpInfo2:
      'By developing next-generation biosensors and a cutting-edge data intelligence platform, we aim to transform diagnostics and lead the way to a more proactive and personalized future.'
  },
  common: {
    lang: 'EN'
  },
  download: {
    language: 'Language',
    product: 'Product',
    unit: 'Unit',
    guide: 'H1 Quick Guide PDF',
    userManul: 'H1 User Manul PDF',
    previous: 'Previous Versions of guides'
  },
  help: {
    help: 'Help Center',
    search: 'Search',
    support: 'Support/Help Center/H1 CGM',
    source: 'HiPPO H1 CGM Online Resources',
    viewAll: 'View all',
    insert: 'How to Insert your H1 CGM',
    setUp: 'How to set up the H1 APP',
    remove: 'How to remove the Device',
    faq: 'HiPPO H1 CGM FAQ',
    freq: 'Frequently Asked Questions',
    moreHelp: 'Need More Help？',
    download: 'Downloadable',
    technicalSupport: 'Technical Support',
    submitForm: 'Submit a Form',
    noData: 'No content found..',
    // Search common keys
    searchKeys: {
      warmUp: 'Warm-up phase failure',
      waterLeakage: 'Water Leakage',
      lowGlucose: 'Low glucose data',
      cannotPair: 'Cannot pair the device with my smartphone'
    }
  },
  faq: {
    faq: 'FAQ',
    general: 'General Questions',
    need: 'Need Help with something？',
    here: 'Here are our most frequently asked questions',
    technical: 'Technical Questions'
  },
  lang: {
    chooseCountry: 'Choose your Country/Region',
    northAmerica: 'North America',
    southAmerica: 'South America',
    europe: 'Europe',
    africa: 'Africa',
    asia: 'Asia',
    other: 'Other'
  },
  // About map city labels
  aboutMap: {
    suzhou: {
      name: 'Suzhou, China',
      subName: 'Manufacturing Site',
      hovData:
        'Global Headquater\nR&D/Data Center\nSales Office cover Asia and Australia'
    },
    dubai: {
      name: 'Dubai',
      subName: 'Regional office',
      hovData: 'Southeast Asia HQ\nSales Team'
    },
    singapore: {
      name: 'Singapore',
      subName: 'Headquarters',
      hovData: 'Southeast Asia Sales Team'
    },
    sanFrancisco: {
      name: 'San Francisco, USA',
      subName: 'Regional Office',
      hovData: 'North America HQ\nSales Team'
    },
    barcelona: {
      name: 'Barcelona',
      subName: 'Sales Office',
      hovData:
        'Global Headquater\nR&D/Data Center\nSales Office cover Asia and Australia '
    }
  }
};
export default en;
